
































import Component from 'vue-class-component';
import {Prop, Mixins} from 'vue-property-decorator';
import {postComment} from '@/clients/UserCommentsClient';
import {ControlParams, CustomParams, EventParams} from 'vue-gtag2';
import {VueGtag} from 'vue-gtag';
import FormErrorsMixin from '@/mixins/FormErrorsMixin.vue';
import {ValidationInstruction} from '@/types/FormErrors';
import {requiredRule} from '@/utils/ValidationRules';

interface CommentForm extends Record<string, string|undefined>{
  body?: string;
}

@Component({
  name: 'NewCommentForm',
})
export default class NewCommentForm extends Mixins(FormErrorsMixin) {
  @Prop({type: String, required: true}) readonly externalId!: string

  private commentForm: CommentForm = {};
  private inProgress = false;
  private validationInstructions: Array<ValidationInstruction> = [
    {field: 'body', rules: [requiredRule]},
  ];

  private onSubmit(): void {
    let success = false;

    this.getFormErrors<CommentForm>(this.validationInstructions, this.commentForm);
    if (this.formErrors.length) {
      this.$bvModal.msgBoxOk('Komentarz nie może być pusty.');
      this.trackSubmitEvent({success});
      return;
    }

    this.inProgress = true;
    postComment(
      this.externalId,
      this.commentForm,
    ).then(response => {
      if (response.ok) {
        success = true;
        this.commentForm = {};
        this.$bvModal.msgBoxOk(
          'Komentarz oczekuje na akceptację. Zostanie opublikowany po zweryfikowaniu przez moderatora',
          {title: 'Komentarz został wysłany'},
        );
        this.$emit('added');
      } else {
        this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + response.statusText, {
          title: 'Błąd',
        });
      }
    }).catch(err => {
      this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + err);
    }).finally(() => {
      this.inProgress = false;
      this.trackSubmitEvent({success});
    });
  }

  private trackSubmitEvent(eventParams: ControlParams | EventParams | CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('submitComment', eventParams);
    }
  }
}
